export const TitleBar = () => {
  return (
    <div
      data-testid="ide-title-bar"
      className="h-9 shrink-0 flex items-center px-4 bg-[var(--sidebar)] border-b border-[var(--border)] select-none"
    >
      <div className="flex items-center gap-2">
        <span className="w-3 h-3 rounded-full bg-[#FF5F57]" />
        <span className="w-3 h-3 rounded-full bg-[#FEBC2E]" />
        <span className="w-3 h-3 rounded-full bg-[#28C840]" />
      </div>
      <div className="flex-1 text-center font-mono text-[11px] tracking-wider text-[var(--muted)]">
        ibrahim-sisman — portfolio — Visual Studio Code
      </div>
      <div className="w-16" />
    </div>
  );
};
